
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "data-privacy-request-ui",
  currentProjectVersion: "static-1.6067",
  depVersions: {
  "data-privacy-request-ui": "static-1.6067",
  "client-types": "static-1.524",
  "data-fetching-client": "static-1.10178",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8585",
  "hub-http-shared-msw-handlers": "static-1.11012",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12033",
  "I18n": "static-7.1727",
  "jasmine-runner": "static-1.7002",
  "quartz": "static-1.7770",
  "react-dlb": "static-1.97",
  "rpc-client-utils": "static-1.5209",
  "ui-components-test-utils": "static-1.6170",
  "UIComponents": "static-3.8979",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.102",
  "foundations-assets": "static-1.5432",
  "foundations-components": "static-1.8855",
  "foundations-components-test-utils": "static-1.6338",
  "foundations-theming": "static-1.5046",
  "hub-http": "static-1.6745",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1548",
  "quartz-core": "static-1.6989",
  "quartz-routing": "static-1.1200",
  "quartz-tracking": "static-1.1149",
  "quick-fetch": "static-1.4270",
  "raven": "static-3.6435",
  "react": "static-7.206",
  "react-rhumb": "static-1-fkhalid-web-vitals-route-attribution.6",
  "SharedI18nStrings": "static-1.191",
  "ui-addon-i18n": "static-1.11691",
  "usage-tracker-core": "static-1.7739",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4047",
  "quartz-webpack": "static-1.3994",
  "bend-plugin-quartz-routing": "static-1.848",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.96",
  "HeadJS": "static-2.839",
  "framer-motion": "static-1.87",
  "hs-test-utils-bend-plugin": "static-1.3696",
  "msw": "static-1.106",
  "msw-config": "static-1.46",
  "testing-library": "static-1.168",
  "ts-schema": "static-1.4437",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "react-utils": "static-2.5721",
  "StyleGuideUI": "static-3.523",
  "jasmine": "static-4.4848",
  "bend-plugin-chirp-manifest": "static-1.619",
  "chirp-fetch": "static-1.2442",
  "HubStyle": "static-2.12340",
  "ui-addon-draggable": "static-3.5295",
  "cssUtils": "static-1.1163",
  "hs-story-utils": "static-1.9967",
  "icons": "static-2.719",
  "react-create-root-preference": "static-1.125",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "ui-images": "static-2.1299",
  "bend-plugin-foundations-components": "static-1.5124",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2762",
  "react-aria": "static-1.80",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3275",
  "ui-fonts": "static-1.1295",
  "foundations-components-legacy": "static-1.1880",
  "bend-plugin-foundations-theming": "static-1.3529",
  "foundations-theming-base": "static-1.4031",
  "stylex": "static-1.50",
  "hs-locale-management": "static-1.446",
  "opentelemetry-fe-types": "static-1.343",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.18",
  "hub-http-janus": "static-1.923",
  "hubspotter-http": "static-1.5013",
  "mobile-manifest-mixins": "static-1.623",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.718",
  "quartz-auth": "static-1.1445",
  "quartz-head": "static-1.1435",
  "quartz-i18n": "static-1.1445",
  "quartz-test": "static-1.1445",
  "trellis-components": "static-1.3294",
  "usage-tracker-container": "static-1.7879",
  "usage-tracker-session-replay": "static-1.5575",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.245",
  "web-vitals": "static-1.22",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3654",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.86",
  "sassPrefix": "static-1.430",
  "stylex-utils": "static-1.194",
  "trellis-theming": "static-1.1588",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11010",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "amplitude-session-replay-browser": "static-1.80"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.6067",
  "client-types": "/client-types/static-1.524",
  "data-fetching-client": "/data-fetching-client/static-1.10178",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8585",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11012",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12033",
  "I18n": "/I18n/static-7.1727",
  "jasmine-runner": "/jasmine-runner/static-1.7002",
  "quartz": "/quartz/static-1.7770",
  "react-dlb": "/react-dlb/static-1.97",
  "rpc-client-utils": "/rpc-client-utils/static-1.5209",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6170",
  "UIComponents": "/UIComponents/static-3.8979",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.102",
  "foundations-assets": "/foundations-assets/static-1.5432",
  "foundations-components": "/foundations-components/static-1.8855",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6338",
  "foundations-theming": "/foundations-theming/static-1.5046",
  "hub-http": "/hub-http/static-1.6745",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1548",
  "quartz-core": "/quartz-core/static-1.6989",
  "quartz-routing": "/quartz-routing/static-1.1200",
  "quartz-tracking": "/quartz-tracking/static-1.1149",
  "quick-fetch": "/quick-fetch/static-1.4270",
  "raven": "/raven/static-3.6435",
  "react": "/react/static-7.206",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-web-vitals-route-attribution.6",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11691",
  "usage-tracker-core": "/usage-tracker-core/static-1.7739",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4047",
  "quartz-webpack": "/quartz-webpack/static-1.3994",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.848",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.96",
  "HeadJS": "/HeadJS/static-2.839",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3696",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.46",
  "testing-library": "/testing-library/static-1.168",
  "ts-schema": "/ts-schema/static-1.4437",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "react-utils": "/react-utils/static-2.5721",
  "StyleGuideUI": "/StyleGuideUI/static-3.523",
  "jasmine": "/jasmine/static-4.4848",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.619",
  "chirp-fetch": "/chirp-fetch/static-1.2442",
  "HubStyle": "/HubStyle/static-2.12340",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5295",
  "cssUtils": "/cssUtils/static-1.1163",
  "hs-story-utils": "/hs-story-utils/static-1.9967",
  "icons": "/icons/static-2.719",
  "react-create-root-preference": "/react-create-root-preference/static-1.125",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "ui-images": "/ui-images/static-2.1299",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5124",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2762",
  "react-aria": "/react-aria/static-1.80",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3275",
  "ui-fonts": "/ui-fonts/static-1.1295",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1880",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3529",
  "foundations-theming-base": "/foundations-theming-base/static-1.4031",
  "stylex": "/stylex/static-1.50",
  "hs-locale-management": "/hs-locale-management/static-1.446",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.343",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "hub-http-janus": "/hub-http-janus/static-1.923",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.623",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.718",
  "quartz-auth": "/quartz-auth/static-1.1445",
  "quartz-head": "/quartz-head/static-1.1435",
  "quartz-i18n": "/quartz-i18n/static-1.1445",
  "quartz-test": "/quartz-test/static-1.1445",
  "trellis-components": "/trellis-components/static-1.3294",
  "usage-tracker-container": "/usage-tracker-container/static-1.7879",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5575",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.245",
  "web-vitals": "/web-vitals/static-1.22",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3654",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.86",
  "sassPrefix": "/sassPrefix/static-1.430",
  "stylex-utils": "/stylex-utils/static-1.194",
  "trellis-theming": "/trellis-theming/static-1.1588",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11010",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80"
}
};
